import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;
const requestKey = (prefix, explicit) => explicit || `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;

const post = (route, values = {}, key) => {
  const auth_key = store.getState().auth.user.auth_key;
  const action = route;
  return axios.post(API_URL + route, { ...values, auth_key, action }, {
    headers: { ...authHeader(), ...(key ? { "Idempotency-Key": key } : {}) },
  });
};

const details = (values = {}) => post("afterlogin/client/clientwallet", values);
const enrol = (values = {}) => post(
  "afterlogin/wallet-contributions/enrol",
  values,
  requestKey("wallet-enrol", values.idempotency_key),
);
const plans = (values = {}) => post("afterlogin/wallet-contributions/view", values);
const cancel = (values = {}) => {
  const id = Number(values.id || values.client_subscription_plan_id);
  const payload = { ...values };
  delete payload.id;
  return post(
    `afterlogin/wallet-contributions/cancel/${id}`,
    payload,
    requestKey(`wallet-cancel-${id}`, values.idempotency_key),
  );
};

export default { details, enrol, plans, cancel };
